import React from 'react';
import {Checkbox} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {ThProps} from '@components/Table/core/Th';
import Th from '@components/Table/core/Th';

type CheckboxCellProps = {
	isChecked: boolean;
	isIndeterminate?: boolean;
	onChange: () => void;
	'data-testid'?: string;
	isHeader?: boolean;
	isDisabled?: boolean;
} & (TdProps | ThProps);

const CheckboxCell = ({
	isChecked,
	isIndeterminate,
	onChange,
	isHeader,
	isDisabled,
	...rest
}: CheckboxCellProps) => {
	const CellComponent = isHeader ? Th : Td;

	const stopPropagation = (e: React.MouseEvent) => {
		e.stopPropagation();
	};

	return (
		<CellComponent {...rest} onClick={stopPropagation}>
			<Checkbox
				isChecked={isChecked}
				isDisabled={isDisabled}
				isIndeterminate={isIndeterminate}
				onChange={onChange}
			/>
		</CellComponent>
	);
};

export default CheckboxCell;
